import type { FunctionComponent } from 'react';
import { SearchType } from './components/Cigarette/types';
import type { LogoImage } from './types';
import { DestinationOption } from '@lt/api/dist/methods/references/types';

/**
 * Список виджетов
 */
export enum WidgetName {
  SEARCHER = 'SEARCHER',
  DIRECTION = 'DIRECTION',
  METAREGIONS = 'METAREGIONS',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
  CIGARETTE = 'CIGARETTE',
  SEARCH = 'SEARCH',
}

export type WidgetsObject = {
  [key in keyof typeof WidgetName]: FunctionComponent | null;
};

export type IDeparture = {
  iata: string;
  id: number;
  iso2: string;
  name_en: string;
  name_ru: string;
  name_ru_form1: string;
  name_ru_form2: string;
  prioritized: boolean;
  priority: number;
  airports?: any;
};

export type StartDate =
  | 'WEEK'
  | 'TWO_WEEKS'
  | 'THREE_WEEKS'
  | 'NEXT_WEEKEND'
  | 'FEB_14'
  | 'FEB_23'
  | 'MARCH_8'
  | 'MARCH_28'
  | 'MAY_1'
  | 'MAY_9'
  | 'OCT_28'
  | 'NOV_4'
  | 'NEW_YEAR';
export type Nights = '2..4' | '4..6' | '7..9' | '10..12' | '12..14';

export interface Configurations {
  utmParams?: Record<string, string>;
  apiDomain?: string;
  partnerKey?: string;
  whitelabelDomain?: string;
  whitelabelName?: string;
  whitelabelLogo?: LogoImage;
  isWhitelabel?: boolean;
  redirect?: '_blank' | '_self';
  widgetName?: WidgetName;
  widgetData?: unknown;
  debug?: boolean;
  disabledCopy?: boolean;
  isBlankBackground?: boolean;
  search_type?: SearchType;
  departure?: any;
  selectedWidget?: WidgetName;
  start_date?: StartDate;
  nights?: Nights;
  adults?: number;
  kids?: number;
  destination_ids?: DestinationOption[];
  searchParams?: Record<string, any>;
  widgetParams?: Record<string, any>;
  isTabsSwitchOn?: boolean;
}

declare global {
  interface Window {
    _lt_partner_key: string;
  }
}
